import { Web3Provider } from '@ethersproject/providers';
import type { RequestArguments } from '@lib/web3/eip/EIP-1193';

export default class EIP1193Provider extends Web3Provider {
  request(args: RequestArguments) {
    return this.jsonRpcFetchFunc(args.method, args.params as any);
  }
}
